import React, { Component } from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";

export default class ExtraParams extends Component {
  render() {
    return (
      <>
        <Row className="mx-1">
          <Col>
            <div className="ck-vol">
              <Col lg="4" sm="6" xs="12" className="escal check-item px-0">
                <FormGroup check>
                  <Label check className="check-label-vol mb-1">
                    <Input type="checkbox" name="escale" />
                    Sans escale uniquement
                  </Label>
                </FormGroup>
              </Col>
              <Col lg="4" sm="6" xs="12" className="ae-vois check-item  px-0">
                <FormGroup check>
                  <Label check className="check-label-vol mb-1">
                    <Input type="checkbox" />
                    Inclure les aéroports voisins
                  </Label>
                </FormGroup>
              </Col>
              <Col lg="4" className="pr-ch check-item right-check px-0">
                <FormGroup check>
                  <Label check className="check-label-vol mb-1">
                    <Input type="checkbox" />
                    Ajouter une alerte de changement de prix
                  </Label>
                </FormGroup>
              </Col>
            </div>
          </Col>
        </Row>
      </>
    );
  }
}
